import { createSlice } from '@reduxjs/toolkit';
import { initialState, commonReducers } from './fileVersionHistory.slice';

const pfaVersionHistorySlice = createSlice({
  name: 'pfaVersionHistory',
  initialState,
  reducers: { ...commonReducers },
});

export default pfaVersionHistorySlice.reducer;
export const {
  setOpenFileVersionHistory,
  setOpenDeleteVersionConfirmationModal,
  addToFileVersions,
  getNextVersions,
  deletedLastVersion,
} = pfaVersionHistorySlice.actions;
